import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetDiagnoses = () => {
    const { zoneApiClient } = useZoneContext();
    
    return useQuery({
        queryKey: ['get-diagnoses'],
        queryFn: async () => {
            const response = await zoneApiClient.getZoneSpecificLookupData(LookupDataEnums.Diagnosis);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve diagnoses.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        cacheTime: 60 * 60 * 1000,
        staleTime: 60 * 60 * 1000,
    });
};
